import useViewer from './useViewer';

type ActiveFlags = 'app-wide-banner' | 'outie';

export default function useFeatureFlag(flag: ActiveFlags) {
  const { viewer } = useViewer();
  const { featureFlags } = viewer;

  return featureFlags?.includes(flag);
}
